import { captureException } from "@sentry/browser";
import { Dispatch } from "redux";
import { AxiosInstance } from "axios";
import { showNotification } from "../../notification/actions";

import { SET_PLAN_DESCRIPTION } from "../types";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";
import { IPlan } from "../../../../common/types";

export default (data: { planId: string, description: IPlan["description"] }, callback: (res: boolean) => void) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<{ success: boolean }>("/change-plan-description", data);
        dispatch({
            type: SET_PLAN_DESCRIPTION,
            payload: { ...res, ...data, user: getState().user },
        });
        if (callback) {
            callback(true);
        }
    } catch (error) {
        if (callback) {
            callback(false);
        }
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};
